import { createContext, useContext, useEffect, useRef } from "react";
import type { CommandAction, CommandRegistryApi } from "../services/commands/commands.types";

const NOOP: CommandRegistryApi = { register: () => () => undefined, list: () => [], get: () => undefined,
  run: async () => ({ status: "blocked", message: "" }), resolve: async () => ({ kind: "none" }), subscribe: () => () => undefined,
  ui: { paletteOpen: false, shortcutsOpen: false, setPaletteOpen: () => undefined, setShortcutsOpen: () => undefined } };
export const CommandRegistryContext = createContext<CommandRegistryApi>(NOOP);
export const useCommandRegistry = (): CommandRegistryApi => useContext(CommandRegistryContext);
export const useRegisterCommands = (actions: CommandAction[]): void => {
  const { register } = useCommandRegistry();
  const latest = useRef(actions);
  latest.current = actions;
  useEffect(() => register(() => latest.current), [register]);
};
